import { Injectable } from '@angular/core';
import { ActionCompletion, Actions, ofActionCompleted, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import {
  UliPdfPreviewModel,
  UliPreviewInformationCriteria,
  UliPreviewInformationSmsCriteria,
} from '../models/uli-information-preview.model';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../../common';
import {
  UliPreviewInformationInitialState,
  UliPreviewInformationLoad,
  UliPreviewInformationSmsSend,
} from './uli-preview-information.actions';
import { UliPreviewInformationState } from './uli-preview-information.state';

@Injectable({ providedIn: 'root' })
export class UliPreviewInformationFacade implements SetInitialStateFacade, LoadDataFacade {
  data$: Observable<UliPdfPreviewModel> = this.store.select(UliPreviewInformationState.getData);
  loaded$: Observable<boolean> = this.store.select(UliPreviewInformationState.getLoaded);

  constructor(private store: Store, private actions: Actions) {}

  loadAll(criteria: UliPreviewInformationCriteria): void {
    this.store.dispatch(new UliPreviewInformationLoad(criteria));
  }

  sendSms(criteria: UliPreviewInformationSmsCriteria): Observable<ActionCompletion<unknown, Error>> {
    this.store.dispatch(new UliPreviewInformationSmsSend(criteria));

    return this.actions.pipe(ofActionCompleted(UliPreviewInformationSmsSend));
  }

  setInitialState(): void {
    this.store.dispatch(new UliPreviewInformationInitialState());
  }
}
